import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import api from '../services/api';
import './AdminFotografos.css';

const AdminFotografos = () => {
  const [fotografos, setFotografos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');
  const [procesando, setProcesando] = useState(null);

  const cargar = async () => {
    try {
      setCargando(true);
      const res = await api.get('/admin/fotografos');
      setFotografos(res.data);
      setError('');
    } catch (e) {
      setError('No se pudieron cargar los fotógrafos');
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { cargar(); }, []);

  const cambiar = async (fotografo, aprobar) => {
    if (!aprobar && !window.confirm(
      `¿Suspender a ${fotografo.nombre}?\n\nNo podrá crear eventos ni subir fotos hasta que lo vuelvas a aprobar.`
    )) return;

    try {
      setProcesando(fotografo.id);
      await api.post(`/admin/fotografos/${fotografo.id}/${aprobar ? 'aprobar' : 'suspender'}`);
      await cargar();
    } catch (e) {
      alert('No se pudo actualizar la cuenta');
    } finally {
      setProcesando(null);
    }
  };

  const formatFecha = (f) => f ? new Date(f).toLocaleDateString('es-MX', {
    day: 'numeric', month: 'short', year: 'numeric'
  }) : '-';

  if (cargando) return <LoadingSpinner mensaje="Cargando fotógrafos..." />;

  const pendientes = fotografos.filter(f => !f.aprobado);

  return (
    <div className="af-page">
      <div className="af-header">
        <div>
          <h1>Fotógrafos</h1>
          <p>Aprueba las cuentas nuevas para que puedan crear eventos y subir fotos.</p>
        </div>
        <span className="af-resumen">
          {fotografos.length} en total · {pendientes.length} por aprobar
        </span>
      </div>

      {error && <div className="af-error">{error}</div>}

      {fotografos.length === 0 && !error && (
        <p className="af-vacio">Aún no hay fotógrafos registrados.</p>
      )}

      <div className="af-lista">
        {fotografos.map((f) => (
          <div key={f.id} className={`af-card${f.aprobado ? '' : ' pendiente'}`}>
            <div className="af-datos">
              <div className="af-nombre">
                {f.nombre}
                <span className={`af-badge ${f.aprobado ? 'ok' : 'espera'}`}>
                  {f.aprobado ? 'Aprobado' : 'Por aprobar'}
                </span>
                {f.stripeConectado && <span className="af-badge stripe">Stripe conectado</span>}
              </div>
              <div className="af-detalle">
                <span>✉️ {f.email}</span>
                {f.telefono && <span>📞 {f.telefono}</span>}
                <span>📅 Se registró el {formatFecha(f.fechaCreacion)}</span>
              </div>
            </div>
            <div className="af-acciones">
              {f.aprobado ? (
                <button
                  className="af-btn suspender"
                  disabled={procesando === f.id}
                  onClick={() => cambiar(f, false)}
                >
                  {procesando === f.id ? 'Guardando...' : 'Suspender'}
                </button>
              ) : (
                <button
                  className="af-btn aprobar"
                  disabled={procesando === f.id}
                  onClick={() => cambiar(f, true)}
                >
                  {procesando === f.id ? 'Guardando...' : '✓ Aprobar'}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminFotografos;
